var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box"},[_c('Left',{staticClass:"left",attrs:{"id":_vm.$route.params.type}}),_c('div',{staticClass:"article"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.html)}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }